import styled, { css } from 'styled-components';
import { green, grey } from '@material-ui/core/colors';

export const UserInfoWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  padding: 1em;
`;

export const UserInfoHeader = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 3em 0;
  flex: 0 0 auto;

  .hugeIcon {
    color: ${green[600]};
    font-size: 5em;
  }
`;

export const UserInfoBody = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;

  .hugeIcon {
    color: ${grey[100]};
    font-size: 5em;
    align-self: center;
    padding: 2rem;
  }
`;

export const Spacer = styled.div`
  display: flex;
  padding: 1em;
`;
